import React, { useEffect, useRef, useState } from 'react';
import StreamingAvatar, {
  AvatarQuality,
  StreamingEvents,
  TaskMode,
  TaskType,
} from '@heygen/streaming-avatar';
import hello_marshall_video from "../../../../assets/videos/hello_marshall.mp4";
import hello_marshall_portrait from "../../../../assets/videos/hello_marshall_portrait.mp4";
import './videoAvatar.index.less';
import * as ChatActions from "../../chat.actions";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../globals/redux/store/store.index';
import ChatInput from '../../chat.input';
import { Close } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingIcon } from '../../../../assets/svgicons';

const AvatarComponent = () => {
  const dispatch = useDispatch();
  const avatarRef = useRef<StreamingAvatar | null>(null);
  const sessionDataRef = useRef<any>(null);
  const [avatar, setAvatar] = useState<StreamingAvatar | null>(null);
  const [sessionData, setSessionData] = useState(null);
  const [userInput, setUserInput] = useState(null);
  const [userInputQueue, setUserInputQueue] = useState<string[]>([]);
  const [playedIndex, setPlayedIndex] = useState(0);
  const [lastMessage, setLastMessage] = useState('');
  const [isSessionActive, setIsSessionActive] = useState(false);
  const [isTerminated, setIsTerminated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const videoElement = useRef<HTMLVideoElement | null>(null);
  const helloVideoRef = useRef<HTMLVideoElement | null>(null);
  const userInputQueueRef = useRef<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [helloVideoCompleted, setHelloVideoCompleted] = useState(true);
  const [helloVideoSrc, setHelloVideoSrc] = useState(hello_marshall_video);


  const chatState = useSelector<RootState, { [key: string]: any }>(
    (state) => state.chatV2Reducer
  );

  useEffect(() => {
    const updateVideoSource = () => {
      if (window.innerWidth < 768) {
        setHelloVideoSrc(hello_marshall_portrait);
      } else {
        setHelloVideoSrc(hello_marshall_video);
      }
    };
    updateVideoSource();
    window.addEventListener("resize", updateVideoSource);

    return () => {
      window.removeEventListener("resize", updateVideoSource);
    };
  }, []);

  useEffect(() => {
    userInputQueueRef.current = userInputQueue;
    setVideoPlaying(userInputQueue.length > 0);
  }, [userInputQueue]);
  useEffect(() => {
    if (userInputQueue.length > 0 && playedIndex === 0) {
      setPlayedIndex(0);
      setUserInput(userInputQueue[0]);
    }
  }, [userInputQueue, playedIndex]);



  const isFirstRender = useRef(true);

  useEffect(() => {
    console.log("useEffect triggered:", chatState?.messages[chatState?.messages?.length - 1]?.message);
    const isFreshInput = sessionStorage.getItem("freshInput") || '0';
    setHelloVideoCompleted(chatState?.messages.length > 0 || chatState?.isNewChat === false);
    if (isFirstRender.current && (isFreshInput == '0' || chatState?.isNewChat)) {
      isFirstRender.current = false;
      return;
    }

    if (
      chatState.lastReceivedMessage?.message_id
    ) {
      sessionStorage.setItem('current_sid', chatState.lastReceivedMessage.chat_session)
      sessionStorage.setItem('freshInput', '0') //reset
      const currentMessage = chatState.messages[chatState.messages.length - 1].message;
      const newChunk =
        lastMessage && currentMessage.startsWith(lastMessage)
          ? currentMessage.slice(lastMessage.length)
          : currentMessage;

      if (newChunk.length) {
        setUserInputQueue((prevQueue) => [...prevQueue, newChunk]);
        setLastMessage(lastMessage + newChunk);
      }
    }
  }, [chatState.messages]);

  const terminateAvatarSession = async () => {
    setIsTerminated(true)
    if (avatarRef.current && sessionDataRef.current) {
      try {
        await avatarRef.current.stopAvatar();
        avatarRef.current = null;
        sessionDataRef.current = null;
        setIsSessionActive(false);
        sessionStorage.setItem("prevPath", location.pathname);
        navigate('/chat')
        console.log('Avatar session terminated successfully');
      } catch (error) {
        console.error('Error terminating avatar session:', error);
        navigate('/chat')
      }
    } else {
      avatarRef.current = null;
      sessionDataRef.current = null;
      setIsSessionActive(false);
      sessionStorage.setItem("prevPath", location.pathname);
      navigate('/chat')
    }
  };

  useEffect(() => {

    const initializeAvatarSession = async (retryCount = 2) => {
      try {
        if (isTerminated) {
          console.log("Not Reconnecting As terminated...");
          return
        }
        let newAvatar, session;
        const token = sessionStorage.getItem("accessToken");

        try {
          newAvatar = new StreamingAvatar({ token });
          await newAvatar.on(StreamingEvents.STREAM_READY, await handleStreamReady);
          await newAvatar.on(StreamingEvents.STREAM_DISCONNECTED, await handleStreamDisconnected);
          await newAvatar.on(StreamingEvents.AVATAR_STOP_TALKING, await handleNextInput);
          
          session = await newAvatar.createStartAvatar({
            quality: AvatarQuality.High,
            avatarName: '0c2771f5301e4cf9b564722028ed21a6_smile', // smile other
            // avatarName: '63eb49a284bf413e8390df3f977b50fd_smile', // prod 
            voice: { voiceId: '55764ad29b5c43eab1c08487a27b9e71' },
            // voice: { voiceId: '38684fb03f264ad48d9054be45951d5e' }, // old best
            // voice: { voiceId: '5941dc50876a4e09aeb0561f58513627' }, // nikhil's approved
            // voice: { voiceId: '55764ad29b5c43eab1c08487a27b9e71' }, // 11labs

          });

          avatarRef.current = newAvatar;
          sessionDataRef.current = session;

          setIsSessionActive(true);
          if (helloVideoRef.current) {
            helloVideoRef.current.pause();
          }
          console.log('Avatar session initialized successfully.');
          return;
        } catch (error) {
          console.log('Avatar session initialized failed: ', error)
        }
      } catch (error) {
        console.error('Error fetching token:', error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    };

    const handleStreamReady = (event: any) => {
      console.log('streaming ready');
      if (event.detail && videoElement.current) {
        videoElement.current.srcObject = event.detail;
        let attemptCount = 0;
        const attemptPlay = () => {
          console.log('attempting to Play');
          videoElement.current?.play().then(() => {
            console.log("Video playing successfully!");
          }).catch((err) => {
            console.warn(`Play attempt ${attemptCount + 1} failed:`, err);
            if (attemptCount < 2) {
              attemptCount++;
              setTimeout(attemptPlay, 2000);
            }
          });
        };
        document.addEventListener("click", attemptPlay, { once: true });

        attemptPlay();
        setLoading(false);
        handleSpeak();
      } else {
        console.error('Stream is not available');
      }
    };


    const maxReconnectAttempts = 1;
    let reconnectAttempts = 0;

    const handleStreamDisconnected = () => {
      console.warn("  Stream disconnected!");
      terminateAvatarSession();
    };

    dispatch(ChatActions.setvideoMode('On'));
    initializeAvatarSession();

    return () => {
      terminateAvatarSession();
    };
  }, []);

  useEffect(() => {
    const terminateSessionOnUnload = async () => {
      await terminateAvatarSession();
    };
    window.addEventListener("beforeunload", terminateSessionOnUnload);

    return () => {
      terminateAvatarSession();
      window.removeEventListener("beforeunload", terminateSessionOnUnload);
    };
  }, []);


  const handleSpeak = async () => {
    if (avatarRef.current && userInput && isSessionActive) {
      try {
        setHelloVideoCompleted(true);
        await avatarRef.current.speak({
          text: userInput,
          task_type: TaskType.REPEAT,
          taskMode: TaskMode.SYNC,
        });
      } catch (error) {
        console.error('Error speaking:', error);
      }
    } else {
      console.warn('Avatar not ready or no input available');
    }
  };

  const handleNextInput = () => {
    setPlayedIndex((prevIndex) => {
      const currentQueue = userInputQueueRef.current;
      const nextIndex = prevIndex + 1;
   
      if (nextIndex < currentQueue.length) {
        // Merge all remaining sentences starting from nextIndex
        const mergedInput = currentQueue.slice(nextIndex).join(' ');
        setUserInput(mergedInput);
        return currentQueue.length; // Jump index to the end
      } else {
        setUserInput(null);
        setUserInputQueue([]);
        setLastMessage('');
        setVideoPlaying(false);
        return 0;
      }
    });
  };

  useEffect(() => {
    if (userInput) handleSpeak();
  }, [userInput, avatarRef.current, isSessionActive]);

  const handleVideoEnd = () => {
    setHelloVideoCompleted(true);
  };

  return (
    <div className="video-container">
      {!helloVideoCompleted && !avatarRef.current ? (
        <video
          ref={helloVideoRef}
          src={helloVideoSrc}
          autoPlay
          playsInline
          onEnded={handleVideoEnd}
          onCanPlay={() => console.log("Video ready to play")}
          onError={(e) => console.error("Error loading video:", e)}
          className="static-video"
        />
      ) : (
        <div className="loader-container">
          <div className="loader-overlay">
            <LoadingIcon color="white" />
          </div>
        </div>
      )
      }
      <div className="video-wrapper" >
        <video ref={videoElement} id="avatarVideo" autoPlay playsInline ></video>
        <IconButton className="close-button" onClick={terminateAvatarSession} aria-label="close">
          <Close fontSize="small" />
        </IconButton>
      </div>
      <div className="input-box" style={{ visibility: loading ? 'hidden' : 'visible' }}>
        <ChatInput videoPlaying={videoPlaying} onTerminateSession={terminateAvatarSession} />
      </div>
    </div>
  );
};

export default AvatarComponent;
